import { ButtonSize, ButtonVariant } from "@galaxy-io/dls/buttons/Button";
import type Icon from "@galaxy-io/dls/icons/Icon";
import Menu, {
  MenuItem as GalaxyMenuItem,
  MenuItemVariant,
  MenuSize,
} from "@galaxy-io/dls/menu/Menu";
import { Placement } from "@galaxy-io/dls/theme/enums";
import { DotsThreeIcon } from "@phosphor-icons/react";
import { type ComponentProps, type ReactNode, useState } from "react";
import { Button } from "@/components/ui/button";

export function MenuItem({
  icon,
  label,
  onClick,
  isDestructive = false,
}: {
  icon: ComponentProps<typeof Icon>["component"];
  label: string;
  isDestructive?: boolean;
  onClick: () => void;
}) {
  return (
    <GalaxyMenuItem
      icon={icon}
      label={label}
      variant={isDestructive ? MenuItemVariant.ERROR : undefined}
      onSelect={onClick}
    />
  );
}

export function OverflowMenu({
  label,
  children,
  icon = DotsThreeIcon,
  variant = ButtonVariant.TERTIARY,
  size = ButtonSize.SMALL,
}: {
  label: string;
  children: (close: () => void) => ReactNode;
  icon?: ComponentProps<typeof Icon>["component"];
  variant?: ButtonVariant;
  size?: ButtonSize;
}) {
  const [open, setOpen] = useState(false);
  return (
    <Menu
      isOpen={open}
      onOpenChange={setOpen}
      placement={Placement.BOTTOM_END}
      size={MenuSize.SMALL}
      trigger={
        <Button ariaLabel={label} tooltip={label} icon={icon} variant={variant} size={size} />
      }
    >
      {children(() => setOpen(false))}
    </Menu>
  );
}
